<script>
    import { language } from './stores';
    import { DateTime } from 'luxon';
    import { parseDate } from './date.js';
    export let data;

    const now = DateTime.now();
</script>

<style>
.content {
    display: flex;
    flex-direction: column;
    padding: 0.2em;
    border-radius: 0.3em;
}

.ongoingcontent {
    background-color: rgba(255, 127, 127, 0.4);
}

.ongoing {
    font-size: 0.8em;
}

.location {
    color: rgba(255, 255, 255, 0.70);
}
</style>

<div class="content" class:ongoingcontent={data.starttime < now && data.endtime > now}>
{#if data.starttime < now && data.endtime > now}
<div class="ongoing">{{en:"happening now!",sv:"pågår nu!"}[$language]}</div>
{/if}
<div class="shortline"><span class="time">{data.starttime.toLocaleString(DateTime.TIME_24_SIMPLE)}</span> – <span class="name">{data.name}</span> {#if data.location != null}<span class="location"> – {data.location}</span>{/if}</div>
</div>